import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-9fe90784"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "page-container"
};
var _hoisted_2 = {
  class: "nav-header-box"
};
var _hoisted_3 = {
  class: "page-inner-container"
};
var _hoisted_4 = {
  class: "page-inner-container",
  style: {
    "padding-top": "32px"
  }
};
var _hoisted_5 = {
  class: "pagination-box"
};
var _hoisted_6 = {
  class: "page-inner-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Banner = _resolveComponent("Banner");
  var _component_NavHeader = _resolveComponent("NavHeader");
  var _component_ExcellentWorkGrid = _resolveComponent("ExcellentWorkGrid");
  var _component_a_pagination = _resolveComponent("a-pagination");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Banner, {
    image: _ctx.BannerImage
  }, null, 8, ["image"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_ctx.userCreationService.activityTypeList && _ctx.userCreationService.activityTypeList.length ? (_openBlock(), _createBlock(_component_NavHeader, {
    key: 0,
    list: _ctx.userCreationService.activityTypeList,
    onChange: _ctx.onActivityTypeChange
  }, null, 8, ["list", "onChange"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_4, [_ctx.userCreationService.userCreationList && _ctx.userCreationService.userCreationList.length ? (_openBlock(), _createBlock(_component_ExcellentWorkGrid, {
    key: 0,
    list: _ctx.userCreationService.userCreationList
  }, null, 8, ["list"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_a_pagination, {
    "show-size-changer": "",
    current: _ctx.userCreationService.pageNum,
    "onUpdate:current": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.userCreationService.pageNum = $event;
    }),
    pageSize: _ctx.userCreationService.pageSize,
    "onUpdate:pageSize": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.userCreationService.pageSize = $event;
    }),
    total: _ctx.userCreationService.total,
    pageSizeOptions: ['12', '16', '20', '24', '28', '32'],
    onChange: _ctx.onPageNumChange,
    onShowSizeChange: _ctx.onShowSizeChange
  }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"])])])]);
}